import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdc25f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-ml-[10px] custom-global-skeleton tw-w-[250px] tw-h-full tw-rounded-[6px]"
}
const _hoisted_2 = {
  key: 1,
  class: "active-path-header"
}
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "circle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.path[0] === _ctx.getPathText() && _ctx.loadingChecklistReportData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.path, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(`parent ${
        index === _ctx.path.length - 1 || !_ctx.path[index + 1] ? 'active' : ''
      }`)
          }, [
            (_ctx.navigate && _ctx.navigate[index] && _ctx.navigate[index].length > 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.navigate[index],
                  class: _normalizeClass('active-navigate'),
                  onClick: _withModifiers(($event: any) => (_ctx.handleNavigate(index)), ["prevent"])
                }, _toDisplayString(item), 9, _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item), 1)),
            (index !== _ctx.path.length - 1 && _ctx.path[index + 1])
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "•"))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]))
}